export default __webpack_public_path__ + "static/media/gallery_20.a45d933d.jpg";